import styled from 'styled-components';

const MainHeader = styled.div`
  font-family: 'CircularStd-Bold';
  font-size: 30px;
`;

export default MainHeader;
